import { render, staticRenderFns } from "./NewBuilt.vue?vue&type=template&id=97edbf20&scoped=true&"
import script from "./NewBuilt.vue?vue&type=script&lang=js&"
export * from "./NewBuilt.vue?vue&type=script&lang=js&"
import style0 from "./NewBuilt.vue?vue&type=style&index=0&id=97edbf20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97edbf20",
  null
  
)

export default component.exports